import Cookies from "universal-cookie";
import axios from "axios";
import Config from "../../config/index";

import { GET_CLIENTS_CREATE_FAILURE, GET_CLIENTS_CREATE_REQUEST, GET_CLIENTS_CREATE_SUCCESS, GET_CLIENTS_DROPDOWN_FAILURE, GET_CLIENTS_DROPDOWN_REQUEST, GET_CLIENTS_DROPDOWN_SUCCESS, GET_CLIENTS_FAILURE, GET_CLIENTS_REQUEST, GET_CLIENTS_SUCCESS, GET_ORG_FAILURE, GET_ORG_REQUEST, GET_ORG_SUCCESS } from "./clientsTypes";
let baseUrl = Config.baseUrl;
// let serviceDeskId = Config.serviceDeskId;

const cookies = new Cookies();
const userData = cookies.get("loginDetailsForSupport");

let email = userData?.data?.email;

const getClientsRequest = () => {
  return {
    type: GET_CLIENTS_REQUEST,
  };
};

const getClientsSuccess = (payload) => {
  return {
    type: GET_CLIENTS_SUCCESS,
    payload: payload,
  };
};

const getClientsFaliure = (error) => {
  return {
    type: GET_CLIENTS_FAILURE,
    payload: error,
  };
};

const getClients = (token) => {
  return (dispatch) => {
    dispatch(getClientsRequest());
    let url = `${baseUrl}/clients_management/clients/get_all`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getClientsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getClientsFaliure(err.message));
      });
  };
};



const getOrgTypesRequest = () => {
  return {
    type: GET_ORG_REQUEST,
  };
};

const getOrgTypesSuccess = (payload) => {
  return {
    type: GET_ORG_SUCCESS,
    payload: payload,
  };
};

const getOrgTypesFailure = (error) => {
  return {
    type: GET_ORG_FAILURE,
    payload: error,
  };
};

const getOrgTypes = (email,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getOrgTypesRequest());
    let url = `${baseUrl}/jira/organizations/by_email?email=${email}`;
    axios
      .get(url, headers)
      .then((response) => {
        console.log(response)
        dispatch(getOrgTypesSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getOrgTypesFailure(err.message));
      });
  };
};
const getClientsForDropdownRequest = () => {
  return {
    type: GET_CLIENTS_DROPDOWN_REQUEST,
  };
};

const getClientsForDropdownSuccess = (payload) => {
  return {
    type: GET_CLIENTS_DROPDOWN_SUCCESS,
    payload: payload,
  };
};

const getClientsForDropdownFailure = (error) => {
  return {
    type: GET_CLIENTS_DROPDOWN_FAILURE,
    payload: error,
  };
};

const getClientsForDropdown = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getClientsForDropdownRequest());
    let url = `${baseUrl}/jira/organizations`;
    axios
      .get(url, headers)
      .then((response) => {
        console.log("responsesas",response)
        dispatch(getClientsForDropdownSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getClientsForDropdownFailure(err.message));
      });
  };
};
const getClientsForCreateRequest = () => {
  return {
    type: GET_CLIENTS_CREATE_REQUEST,
  };
};

const getClientsForCreateSuccess = (payload) => {
  return {
    type: GET_CLIENTS_CREATE_SUCCESS,
    payload: payload,
  };
};

const getClientsForCreateFailure = (error) => {
  return {
    type: GET_CLIENTS_CREATE_FAILURE,
    payload: error,
  };
};

const getClientsForCreate = (orgId,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getClientsForCreateRequest());
    let url = `${baseUrl}/jira/organizations/customers?org_id=${orgId}`;
    axios
      .get(url, headers)
      .then((response) => {
        console.log("responsesas",response)
        dispatch(getClientsForCreateSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getClientsForCreateFailure(err.message));
      });
  };
};

export { getClients,getOrgTypes,getClientsForDropdown,getClientsForCreate};
